import React from 'react';

import ProductImage from './product-image';
import Link from '../../shared/components/hyperlink';
import DisclaimerTooltip from '../../shared/components/disclaimer-tooltip';
import { Helpers } from '../../core/src/helpers';
import { StoreAppAPI } from '../../core/src/storeapp-api-client';

import '../css/tech-specs.less';


const NULL_SPECS = {
	images: [],
	specs: [],
	disclaimers: []
};

 class TechSpecs extends React.Component {

	 constructor(props) {
		 super(props);
		 this.state = {
			 techSpecs: null,
             requesting: false
		 }
	 }

    fetchTechSpecs = (sku) => {
        let storeAppAPI = new StoreAppAPI();
        return storeAppAPI.product.get(sku,"specs,disclaimers,images,name,linkUrl,attributes,defaultImages",true).then((resp) => {
            if (resp.status == "200" && resp.data) {
                return resp.data;
            }
        });
    }

    setTechSpecs = () => {
        const { requesting } = this.state;
        const { sku } = this.props;

        if (sku && !requesting) {
            this.setState({
                requesting: true
            })
            this.fetchTechSpecs(sku).then((response) => {
                this.setState({
                    techSpecs: response,
                    requesting: false
                })
            });
        }
    }

    componentDidMount() {
        this.setTechSpecs();
    }

    componentDidUpdate(prevProps){
        const { sku:newSku } = this.props;
        const { sku:prevSku} = prevProps;

        if(newSku !== prevSku){
            this.setTechSpecs()
        }
    }

    render() {
		const { techSpecs } = this.state;
        const { sku } = this.props;
        let footnoteRegex = Helpers.footnoteRegex();
        const ankerExtractRegex = /<a href="(.*?)">([^<]+)<\/a>/;
        const ankerMatch = (str) => str.match(ankerExtractRegex);
        const linkRegex = /((https)|(http)):\/\/store.hp.com\/us\/en\/pdp\//;

        const prodSpec = techSpecs || NULL_SPECS;

        let images = [];
        return (
            this.props.children ? this.props.children(this.state) :
            <div className='tech-specs'>
                <div className="specs-content">
                    <ProductImage link={prodSpec.linkUrl} product={prodSpec} maxImgWidth={270} />
                    <div tabIndex={0} aria-label={prodSpec.name} className="specs-product-title">{prodSpec.name}</div>
                    {prodSpec.specsShortDescription &&
                        <p 
                            className='specs-product-description' 
							dangerouslySetInnerHTML={ Helpers.createMarkup(prodSpec.specsShortDescription)} 
							aria-label={prodSpec.specsShortDescription}
							tabIndex={0}
                        />
                    }
                    <div className="specs-table">
                        {prodSpec.specs.map((spec,i) => {
                            const { type, value } = spec;
                            return(
                                <div className="specs-row" key={i}>
                                    <div tabIndex={0} aria-label={type} className="specs-cell spec-name">{type}</div>
                                    <div className="specs-cell spec-values">
                                    {
                                        value && value.constructor === Array && value.map((val, i) => {
                                            const match = ankerMatch(val)
                                            if(match){
                                                let [string, link, name] = match;
                                                //if link goes to pdp, use app PDP
                                                link = link.replace(linkRegex,"/pdp/");

                                                return(<Link key={i} className='spec-value' to={link} newTab={ true }>{name}</Link>)
                                            }
                                            return(
                                                <DisclaimerTooltip key={i} string={val} footnoteRegex={footnoteRegex} disclaimers={prodSpec.disclaimers}>
                                                    {
                                                        (string, replaced) => {
                                                           const htmlRegex = new RegExp('(<([^>]+)>)', 'gi');
                                                            if ( typeof string === 'string' && htmlRegex.test(string) ) {
                                                                const specValHtml = `${ ( i !== 0 && !replaced ) ? '<br/>' : '' }${ string }`;
                                                                return (<div tabIndex={0} aria-label={specValHtml} className='spec-value' dangerouslySetInnerHTML={ Helpers.createMarkup(specValHtml) } />)
                                                            } else {
                                                                return (<div tabIndex={0} aria-label={string} className='spec-value'>{ i !== 0 && !replaced && <br/> }{ string }</div>);
                                                            }
                                                        }
                                                    }
                                                </DisclaimerTooltip>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="specs-disclaimer">
                    {   prodSpec.disclaimers &&
                        <ul className="disclaimer-list">
                            {prodSpec.disclaimers.map((disclaimer,i) => {
                                return (
                                    <li tabIndex={0} aria-label={disclaimer} key={i}>{disclaimer}</li>
                                );
                            })}
                        </ul>
                    }
                    </div>
                </div>
            </div>
        );
    }
};

export default TechSpecs;
